import {
  CREATE_IMPORT,
  RECEIVE_IMPORT,
  RECEIVE_ERROR,
  RESET_REQUEST
} from '../../actions/CensusImports/consts'

const initialState = {
  requestInProgress: false,
  requestComplete: false,
  created: false,
  generalError: null,
  resourceErrors: [],
  attributes: null,
  responseAttributes: null,
  responseHeaders: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
  case CREATE_IMPORT:
    return {
      ...state,
      requestInProgress: true,
      requestComplete: false,
      created: false,
      attributes: action.attributes
    }
  case RECEIVE_IMPORT:
    return {
      ...state,
      nonce: action.nonce,
      requestInProgress: false,
      requestComplete: true,
      created: true,
      responseAttributes: action.responseAttributes,
      responseHeaders: action.responseHeaders
    }
  case RECEIVE_ERROR:
    return {
      ...state,
      requestInProgress: false,
      requestComplete: true,
      created: false,
      generalError: action.generalError,
      resourceErrors: action.resourceErrors
    }
  case RESET_REQUEST:
    return { ...initialState }
  default:
    return { ...state }
  }
}
